import React, {useEffect, useState} from 'react';
import Intro from "../components/intro";
import InputForms from "../components/InputForms";
import ImageForm from "../components/ImageForm";
import AppPreview from "../components/AppPreview";
import {toast} from "react-toastify";
import {v4 as uuidv4} from "uuid";
import {generateZipFromFormData, uploadToS3} from "../services/awsHandler";
import axios from "axios";

const WhitelabelForm = (props) => {
    const { } = props;
    const root = document.documentElement;

    const [assignee, setAssignee] = useState(null);
    const [businessEmail, setBusinessEmail] = useState("");
    const [appName, setAppName] = useState("Olympus Top Fitness");
    const [secondAppName, setSecondAppName] = useState("");
    const [thirdAppName, setThirdAppName] = useState("");
    const [mainColor, setMainColor] = useState("#192F51");
    const [textColor, setTextColor] = useState("#fff");
    const [secondaryColor, setSecondaryColor] = useState("#989696");
    const [logo, setLogo] = useState();
    const [logoFile, setLogoFile] = useState();
    const [splash, setSplash] = useState();
    const [splashFile, setSplashFile] = useState();
    const [backgroundImg, setBackgroundImg] = useState();
    const [backgroundImgFile, setBackgroundImgFile] = useState();
    const [appleIcon, setAppleIcon] = useState();
    const [appleIconFile, setAppleIconFile] = useState();
    const [andriodIcon, setAndriodIcon] = useState();
    const [andriodIconFile, setAndriodIconFile] = useState();
    const [notificationIcon, setNotificationIcon] = useState();
    const [notificationIconFile, setNotificationIconFile] = useState();
    const [resetChildState, setResetChildState] = useState(false);


    root.style.setProperty("--app-main-color", mainColor);
    root.style.setProperty("--app-text-color", textColor);
    root.style.setProperty("--app-secondary-color", secondaryColor);

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Validation
        if (
            !assignee ||
            !businessEmail ||
            !appName ||
            !secondAppName ||
            !thirdAppName ||
            !mainColor ||
            !textColor ||
            !secondaryColor ||

            !appleIconFile ||
            !andriodIconFile ||
            !notificationIconFile ||
            !splashFile ||
            !logoFile ||
            !backgroundImgFile
        ) {
            toast.error("All fields are required.");
            return;
        }

        // Data to be sent to the server
        const data = {
            assignee: assignee.mail,
            businessEmail,
            appName,
            secondAppName,
            thirdAppName,
            mainColor,
            textColor,
            secondaryColor
        };

        try {

            const formData = new FormData();
            formData.append('appleIconFile', appleIconFile);
            formData.append('andriodIconFile', andriodIconFile);
            formData.append('notificationIconFile', notificationIconFile);
            formData.append('splashFile', splashFile);
            formData.append('logoFile', logoFile);
            formData.append('backgroundImgFile', backgroundImgFile);

            const folder = `${appName}---${uuidv4()}`;
            const params = {
                Bucket: process.env.REACT_APP_BUCKET_NAME,
                Key: `${folder}/appDetails.json`,
                Body: JSON.stringify(data),
                ACL: 'private',
                ContentType: 'application/json'
            };

            uploadToS3(params)

            const imageParams = {
                Bucket: process.env.REACT_APP_BUCKET_NAME,
                ACL: 'private',
            };

            for (const key of formData.keys()) {
                if (formData.get(key)) {
                    const imageFile = formData.get(key);
                    imageParams.Key = `${folder}/${imageFile.name}`;
                    imageParams.Body = imageFile;
                    imageParams.ContentType = imageFile.type;
                    uploadToS3(imageParams)
                }
            }

            const zipFile = await generateZipFromFormData(formData, JSON.stringify(data));

            // Upload ZIP file to S3
            const zipParams = {
                Bucket: process.env.REACT_APP_BUCKET_NAME,
                Key: `${folder}/whitelabel.zip`,
                Body: zipFile,
                ACL: 'private',
                ContentType: 'application/zip'
            };

            uploadToS3(zipParams);

            toast.success("Your data is submitted successfully");
            // setResetChildState(true);
            // resetState();
        } catch (error) {
            console.error('Error sending data:', error);
        }
    };

    return (
        <div className="branded-app-main-wrapper">
            <Intro/>
            <form onSubmit={handleSubmit}>

                <InputForms
                    mainColor={mainColor}
                    setMainColor={setMainColor}
                    textColor={textColor}
                    setTextColor={setTextColor}
                    secondaryColor={secondaryColor}
                    setSecondaryColor={setSecondaryColor}
                    assignee={assignee}
                    setAssignee={setAssignee}
                    appName={appName}
                    setAppName={setAppName}
                    secondAppName={secondAppName}
                    setSecondAppName={setSecondAppName}
                    thirdAppName={thirdAppName}
                    setThirdAppName={setThirdAppName}
                    businessEmail={businessEmail}
                    setBusinessEmail={setBusinessEmail}
                />

                <ImageForm
                    setLogo={setLogo}
                    setLogoFile={setLogoFile}
                    setSplash={setSplash}
                    setSplashFile={setSplashFile}
                    setBackgroundImg={setBackgroundImg}
                    setBackgroundImgFile={setBackgroundImgFile}
                    setAndriodIcon={setAndriodIcon}
                    setAndriodIconFile={setAndriodIconFile}
                    setAppleIcon={setAppleIcon}
                    setAppleIconFile={setAppleIconFile}
                    setNotificationIcon={setNotificationIcon}
                    setNotificationIconFile={setNotificationIconFile}
                    appName={appName}
                    resetChildState={resetChildState}
                    setResetChildState={setResetChildState}
                />

                <AppPreview
                    logo={logo}
                    splash={splash}
                    backgroundImg={backgroundImg}
                    appleIcon={appleIcon}
                    appName={appName}
                />
                <div className="actions-btn-wrapper">
                    <button className="continue-btn">אישור</button>
                </div>
            </form>
        </div>
    );
};

export default WhitelabelForm;